// extracted by mini-css-extract-plugin
var _1 = "eWFrs";
var _2 = "QkHNQ";
var _3 = "guKyc";
var _4 = "NuyjV";
var _5 = "OTrqx";
export { _1 as "base", _2 as "centered", _3 as "failed", _4 as "succeeded", _5 as "warning" }
